export interface EditorPreferences {
  snapMode: 'grid' | 'off';
  autoSaveEnabled: boolean;
  activeRightPanel: 'inspector' | 'list' | 'prefabs' | 'history';
}

const PREF_KEY = 'sstk-editor-preferences';

export function loadEditorPreferences(): Partial<EditorPreferences> {
  try {
    const raw = localStorage.getItem(PREF_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export function saveEditorPreferences(prefs: Partial<EditorPreferences>): void {
  try {
    localStorage.setItem(PREF_KEY, JSON.stringify(prefs));
  } catch {
    // Best effort: localStorage can be unavailable (private mode, quota).
  }
}
